//#region Imports
const url = "/api/v1/";
import {
  collection,
  getDocs,
  addDoc,
  query,
  where,
  orderBy,
  or,
  and,
  doc,
  updateDoc,
  deleteDoc,
  getDoc,
  setDoc,
  Timestamp,
  writeBatch,
  limit
} from "firebase/firestore";

import { firestore } from "_utils/firebase-app";
//#endregion Imports

/**
 * Function to fetch employee location data from Firestore.
 * @param {*} params : date, employeeId, iata
 * @returns  {Promise} Resolves with employee location data or null if not found.
 */
export const getEmployeeLocationData = (params) => {
  return new Promise(async (resolve, reject) => {

    console.log("Fetching employee location data...", params);

    let date = new Date(params.date);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    const docId = `${params.iata}_${params.employeeId}_${year}-${month}-${day}`;

    console.log('search for doc id', docId);

    const locationDocRef = doc(firestore, "employeesLocations", docId);

    try {
      const docSnap = await getDoc(locationDocRef);
      if (docSnap.exists()) {
        resolve({ id: docSnap.id, ...docSnap.data() });
      } else {
        alert("No location data found for this employee on the selected date.");
        resolve(null);
      }
    } catch (error) {
      console.error("Error fetching employee location data:", error);
      reject(error);
    }
  });
};
